var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0208 23.7432V11.9842C14.0211 11.837 14.0624 11.6927 14.1405 11.5662C14.2185 11.4398 14.3304 11.3359 14.4645 11.2654C14.5986 11.195 14.7498 11.1606 14.9025 11.1658C15.0551 11.171 15.2034 11.2157 15.332 11.2952L24.8266 17.173C24.9469 17.2472 25.0458 17.3494 25.1143 17.4701C25.1828 17.5908 25.2187 17.7261 25.2187 17.8637C25.2187 18.0012 25.1828 18.1366 25.1143 18.2573C25.0458 18.378 24.9469 18.4801 24.8266 18.5543L15.332 24.4338C15.2034 24.5133 15.0551 24.558 14.9025 24.5632C14.7498 24.5684 14.5986 24.534 14.4645 24.4636C14.3304 24.3931 14.2185 24.2892 14.1405 24.1628C14.0624 24.0363 14.0211 23.892 14.0208 23.7448V23.7432Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07635 17.8646C2.07635 8.82069 9.42966 1.48877 18.5 1.48877C27.5703 1.48877 34.9236 8.82069 34.9236 17.8646C34.9236 26.9086 27.5703 34.2405 18.5 34.2405C9.42966 34.2405 2.07635 26.9086 2.07635 17.8646ZM18.5 3.72184C14.7381 3.72184 11.1304 5.21188 8.47035 7.86417C5.81032 10.5165 4.31594 14.1137 4.31594 17.8646C4.31594 21.6155 5.81032 25.2128 8.47035 27.8651C11.1304 30.5174 14.7381 32.0074 18.5 32.0074C22.2618 32.0074 25.8696 30.5174 28.5296 27.8651C31.1896 25.2128 32.684 21.6155 32.684 17.8646C32.684 14.1137 31.1896 10.5165 28.5296 7.86417C25.8696 5.21188 22.2618 3.72184 18.5 3.72184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.4a2c54841f0b5c3f1edcb2279ab764c0.svg";
export { ForwardRef as ReactComponent };